export default "__VITE_ASSET__BoHrHg7Z__"